import { useEffect, useState } from "react";
import AppLayout from "@/components/AppLayout";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Users, Trophy, MessageSquare } from "lucide-react";

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/overview").then(r => setData(r.data)).catch(() => {}); }, []);
  const kpis = [
    { label: "Atletas ativos", value: data?.active_athletes ?? "—", icon: Users, testid: "admin-kpi-athletes-count" },
    { label: "Torneios próximos", value: data?.upcoming_tournaments ?? "—", icon: Trophy },
    { label: "Aulas Exp. pendentes", value: data?.experimental_pending ?? "—", icon: MessageSquare },
  ];
  return (
    <AppLayout kind="admin">
      <h1 className="text-3xl sm:text-4xl text-white font-semibold mb-2">Painel Administrativo</h1>
      <p className="text-slate-400 mb-8">Visão geral operacional do GSX.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {kpis.map(k => (
          <Card key={k.label} data-testid={k.testid} className="bg-transparent gsx-card-dark p-5">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-amber-500/15 border border-amber-500/30 flex items-center justify-center">
                <k.icon className="w-4 h-4 text-amber-400" />
              </div>
              <div>
                <div className="text-xs text-slate-400 uppercase tracking-widest">{k.label}</div>
                <div className="text-3xl text-white font-semibold">{k.value}</div>
              </div>
            </div>
          </Card>
        ))}
      </div>
      <Card className="bg-transparent gsx-card-dark p-6">
        <h3 className="text-white font-semibold mb-4">Feedbacks recentes</h3>
        <div className="space-y-2 text-sm">
          {data?.recent_feedback?.map(f => (
            <div key={f.id} className="flex justify-between border-b border-white/5 pb-2">
              <div className="text-slate-300">Horas: {f.hours_trained} • Plano {f.plan_completion}/5 • Motivação {f.motivation}/5</div>
              <div className="text-slate-500 text-xs">{new Date(f.created_at).toLocaleDateString('pt-BR')}</div>
            </div>
          ))}
          {!data?.recent_feedback?.length && <div className="text-slate-400">Sem feedbacks recentes.</div>}
        </div>
      </Card>
    </AppLayout>
  );
}
